module.exports = __webpack_public_path__ + "static/media/gryphon_musee_urbanlandscape_1.4fa14935.jpg";